import { Component, Input, OnInit } from "@angular/core";
import { FormArray } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { MessageService } from "../../services/message.service";
import { TermsService } from "../../services/terms.service";
import { CommonService } from "../../services/common.service";
import { RiskConvergenceService } from "../../services/risk-convergence.service";
import { RiskCreateDialogComponent } from "../../../pages/risk-convergence/risk-create-dialog/risk-create-dialog.component";
@Component({
  selector: "app-selection-tree-listing",
  templateUrl: "./selection-tree-listing.component.html",
  styleUrls: ["./selection-tree-listing.component.scss"],
})
export class SelectionTreeListingComponent implements OnInit {
  @Input() items: any = [];
  @Input() tree: any;
  @Input() context: any;
  @Input() disabled = false;
  @Input() fromPage = "";
  @Input() parentItem: any;
  @Input() grandParentItem: any;
  loading = false;
  @Input() userList: any;
  @Input() frequencyList: any;
  @Input() captureContext = true;
  @Input() evidenceList: any = [];
  @Input() functionList: any = [];
  termDetails: any;
  monthList: any = [];
  months: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  years: number[] = [];
  selectedMetric: any;
  selectedMetricObj: any;
  termMetricList: any;
  selectedtermMetricList: any;
  okrTermMetricList: any;
  selectedPeriod: any;
  selectedCompliance: any;
  selectedOwner: any;
  selectedDate: any;
  selectedComment: any;
  documentFile: any;
  documentFilename: any;
  loadingEvidence = false;
  createForm: FormArray;
  subCategoryCreate = false;
  subCategoryName: any = "";
  termName: any = "";
  termFunction: any = "";
  termFulfilledBy: any = "";
  termEvidence: any = "";
  termDomain: any = "";
  termDOD: any = "";
  iframeEmbedded = false;
  dialogRef: any;
  is_vendor = false;

  constructor(
    private readonly termService: TermsService,
    private readonly toastrService: ToastrService,
    public dialog: MatDialog,
    private readonly spinner: NgxSpinnerService,
    private readonly messageService: MessageService,
    private readonly commonService: CommonService,
    private readonly riskService: RiskConvergenceService
  ) {}

  ngOnInit(): void {
    this.is_vendor = JSON.parse(
      localStorage.getItem("permission") ?? "{}"
    )?.is_vendor;

    this.messageService.getIframeData().subscribe((res: any) => {
      this.iframeEmbedded = typeof res !== "object";
    });
    this.generateYears();
  }

  generateYears() {
    const startYear = 2022;
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push(year);
    }
  }

  toggleAccordion(event: Event | null, item: any) {
    if (event) {
      event.stopPropagation();
    }
    item.expanded = !item.expanded;

    if (item.expanded && this.context?.componentParent?.collapse) {
      this.context.componentParent.collapse(item);
    }
  }

  getColor() {
    return "";
  }

  getSelectionCounts(item: any): { selected: number; total: number } {
    if (!item) return { selected: 0, total: 0 };
    if (item.level === 'risk' || item.level === 'goal' || item.level === 'term' || !item.children) {
      return { selected: item.selected ? 1 : 0, total: 1 };
    }
    let total = 0;
    let selected = 0;
    const countLeaves = (node: any) => {
      if (!node.children || node.children.length === 0) {
        total++;
        if (node.selected) selected++;
      } else {
        node.children.forEach((child: any) => countLeaves(child));
      }
    };
    countLeaves(item);
    return { selected, total };
  }

  isAllSelected(item: any): boolean {
    if (item.level === 'risk' || item.level === 'goal' || item.level === 'term' || !item.children) {
      return !!item.selected;
    }
    if (item.selection_type === 'all') return true;
    if (item.selection_type === 'none') return false;
    const stats = this.getSelectionCounts(item);
    return stats.total > 0 && stats.selected === stats.total;
  }

  isIndeterminate(item: any): boolean {
    if (item.level === 'risk' || item.level === 'goal' || item.level === 'term' || !item.children) {
      return false;
    }
    if (item.selection_type === 'intermediate') return true;
    const stats = this.getSelectionCounts(item);
    return stats.selected > 0 && stats.selected < stats.total;
  }

  selectGoals(event: any, item: any) {
    if (!this.disabled && event.type === "change") {
      this.context.componentParent.selectGoals(item);
    }
  }
  emitCommentValue(event: any, item: any, type: any) {
    if (type === "comments") {
      item.context = event.target.value;
    }
    if (type === "frequency") {
      item.frequency = event.value;
    }
    if (type === "due_date") {
      item.due_date = moment(event.target.value).format("YYYY-MM-DD");
    }
    this.context.componentParent.selectGoals(item);
  }

  add(event: any, item: any) {
    event.stopPropagation();
    if (!item.expanded) {
      this.toggleAccordion(event, item);
    }
    if (item.level === "category") {
      if (!item.children) {
        item.children = [];
      }
      item.children.push({
        id: "",
        term_category_id: item.uuid,
        term_category: item.id,
        name: "",
        display_name: "",
        is_custom: true,
        level: "subcategory",
      });
    } else {
      if (!item?.children) {
        item.children = [];
      }
      item.children.push({
        id: "",
        subcategory_id: item.id,
        name: "",
        title: "",
        description: "",
        is_custom: true,
        level: "term",
        category_id: item.category_id,
        term_subcategory: item.id,
      });
    }
  }

  addTermsItems(i: any, j: any) {
    if (!this.createForm.value[i].subcategories[j].terms) {
      this.createForm.value[i].subcategories[j].terms = [];
    }
    this.createForm.value[i].subcategories[j].terms.push({
      title: "",
      prefix: "",
      impact: "",
    });
  }

  //Metrics update
  selectedMatricEvent(e: any, val = null) {
    if (val) {
      this.selectedMetricObj = this.termDetails?.instancemetrics.filter(
        (item: any) => item.id === parseInt(val, 10)
      )[0];
      this.selectedtermMetricList = this.termMetricList.filter(
        (item: any) => item.id === parseInt(val, 10)
      )[0];
    } else {
      this.selectedMetricObj = this.termDetails?.instancemetrics?.filter(
        (item: any) => item.id === parseInt(e.value, 10)
      )[0];
      this.selectedtermMetricList = this.termMetricList.filter(
        (item: any) => item.id === parseInt(e.value, 10)
      )[0];
    }
    this.loadMonthDetails();
  }

  onClickMetrics(item: any, modal: any) {
    let dialogWidth = "80vw";

    if (window.innerWidth > 1200) {
      dialogWidth = "70vw";
    }

    if (window.innerWidth >= 1400) {
      dialogWidth = "50vw";
    }
    this.selectedMetricObj = "";
    this.selectedPeriod = "";
    this.selectedMetric = "";

    this.termDetails = item;
    this.dialogRef = this.dialog.open(modal, {
      width: dialogWidth,
      disableClose: true,
      autoFocus: false,
    });

    this.spinner.show();
    this.termService
      .getTermMetrics(this.termDetails?.project_id, this.termDetails?.id)
      .subscribe((res: any) => {
        this.termMetricList = res;
        this.selectedMetricObj = null;
        this.selectedMetric = null;
        this.selectedPeriod = "2025";
        if (this.termDetails.instancemetrics?.length > 0) {
          const value = this.termDetails.instancemetrics[0].id;
          this.selectedMetric = value.toString();
          this.selectedMatricEvent(null, value);
        }
        this.spinner.hide();
      });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  selectedMatricYear() {
    this.loadMonthDetails();
  }
  loadMonthDetails() {
    if (this.selectedPeriod) {
      this.monthList = [];
      const monthObj: any = [];
      this.months.forEach((m: any, index: any) => {
        monthObj.push({ month: m, month_id: index + 1, value: 0, edit: false });
      });
      this.monthList = monthObj;
      const metricYearDetails =
        this.selectedtermMetricList?.months_data?.filter(
          (item: any) =>
            item.reporting_year === parseInt(this.selectedPeriod, 10)
        )[0];
      metricYearDetails?.details?.forEach((val: any) => {
        this.monthList.forEach((m: any) => {
          if (val.reporting_month === m.month_id) {
            m.value = val?.current_value;
          }
        });
      });
    }
  }
  matricTarVal() {
    const payload: any = [];
    this.monthList.forEach((m: any) => {
      payload.push({
        reporting_month: m.month_id,
        reporting_year: this.selectedPeriod,
        instancemetrics_id: this.selectedMetricObj?.instancemetrics,
        current_value: m.value,
        comments: "",
      });
    });
    const data = {
      project_id: this.termDetails?.project_id,
      term_id: this.termDetails?.id,
      termmetrics: payload,
    };
    this.spinner.show();
    this.termService.setTermMetrics(data).subscribe(() => {
      this.spinner.hide();
      this.toastrService.success("Metric updated successfully");
      this.dialog.closeAll();
    });
  }

  editColum(i: any) {
    this.monthList[i].edit = true;
  }
  //Metrics update End
  termEvidenceList: any = [];

  onClickEvidence(item: any, modal: any) {
    this.termEvidenceList = [];
    this.selectedDate = "";
    this.selectedOwner = "";
    this.selectedComment = "";
    this.documentFile = "";
    this.documentFilename = "";
    this.selectedCompliance = "";
    this.dialogRef = this.dialog.open(modal, {
      width: "40vw",
      disableClose: true,
      autoFocus: false,
    });
    this.termDetails = item;
    if (item?.projectterm_id) {
      this.loadingEvidence = true;
      this.spinner.show();
      this.termService
        .getTermEvidence(item?.projectterm_id)
        .subscribe((res: any) => {
          this.loadingEvidence = false;
          this.termEvidenceList = res;
          this.spinner.hide();
        });
    }
  }

  onFileSelected(e: any) {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      this.commonService.validateFileSize(file).subscribe((isValid) => {
        if (!isValid) {
          this.toastrService.error("Please upload less than 50MB");
          return;
        }
        if (file) {
          this.documentFile = file;
          this.documentFilename = file?.name;
        }
      });
    }
  }

  showError() {
    this.toastrService.error("Enter all the fields");
  }

  saveEvidence() {
    if (this.selectedDate && this.selectedComment) {
      this.spinner.show();
      this.selectedDate = moment(this.selectedDate).format("YYYY-MM-DD");
      const data = new FormData();
      const complianceMet: any = this.selectedCompliance === "Met";
      if (complianceMet) {
        if (!this.selectedOwner || !this.documentFile) {
          this.showError();
          return;
        }
        data.append("file", this.documentFile);
        data.append("owner_id", this.selectedOwner);
      }
      data.append("term_id", this.termDetails?.id);
      data.append("project_id", this.termDetails?.project_id);
      if (this.termDetails?.projectterm_id) {
        data.append("projectterm_id", this.termDetails?.projectterm_id);
      }
      data.append("date", this.selectedDate);
      data.append("comment", this.selectedComment);
      data.append("compliance_met", complianceMet);
      this.termService.createTermEvidence(data).subscribe((res: any) => {
        if (res?.projectterm?.id) {
          this.termDetails.projectterm_id = res?.projectterm?.id;
          this.context.componentParent.selectGoals(this.termDetails);
        }
        this.termEvidenceList.push(res);
        this.selectedDate = "";
        this.selectedOwner = "";
        this.selectedComment = "";
        this.documentFile = "";
        this.documentFilename = "";
        this.spinner.hide();
      });
    } else {
      this.showError();
    }
  }

  hasTerms(item: any): boolean {
    if (item.level === "category") {
      return item?.children?.some((child: any) => child.level === "term");
    }
    if (item.level === "subcategory") {
      return item?.children?.some((child: any) => child.level === "term");
    }
    return true; // For other levels, assume terms can be selected
  }

  isObjective(item: any): boolean {
    if (item.key_results && !item.goals) {
      return true;
    }

    if (item.goals === undefined && item.key_results) {
      return true;
    }

    return false;
  }

  isGoal(item: any): boolean {
    return "goal_name" in item && "goal_description" in item;
  }

  isRiskDomain(item: any): boolean {
    if (item.sub_domains && !item.risks) {
      return true;
    }

    if (item.risks === undefined && item.sub_domains) {
      return true;
    }

    return false;
  }

  closeAccordian(_item: any) {
    this.subCategoryCreate = false;
  }

  writeData(category: any) {
    const payload = {
      categories: category,
      deleted_categories: [],
      deleted_subcategories: [],
      deleted_terms: [],
    };
    this.spinner.show();

    this.termService.updateTerms(payload).subscribe(
      () => {
        this.messageService.setUpdatedDeliveryObligation("test");
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        throw error;
      }
    );
  }

  onSubCategoryNameChange(value: string) {
    this.subCategoryName = value;
  }

  closeSubCategory(event: any, item: any) {
    event.stopPropagation();
    const parent = this.context.componentParent.termsArray.find(
      (obj: any) => obj.id === item.term_category
    );
    if (parent.children && Array.isArray(parent.children)) {
      parent.children = parent.children.filter((child: any) => child !== item);
    }
    this.items = this.items.filter((i: any) => i.id !== item.id);
  }

  updateSubCategory(event: any, item: any) {
    event.stopPropagation();
    this.writeData([
      {
        id: item.term_category,
        subcategories: [
          {
            name: this.subCategoryName,
            prefix: "",
            impact: "",
            edit: false,
            edit_name: this.subCategoryName,
          },
        ],
      },
    ]);
  }

  closeTerm(event: any, item: any) {
    event.stopPropagation();
    const parent = this.context.componentParent.termsArray.find(
      (obj: any) => obj.id === item.category_id
    );
    const subcategory = parent.children?.find(
      (child: any) => child.id === item.subcategory_id
    );
    if (subcategory.children && Array.isArray(subcategory.children)) {
      subcategory.children = subcategory.children.filter(
        (child: any) => child !== item
      );
    }
  }

  updateTerm(item: any) {
    this.writeData([
      {
        id: item.category_id,
        subcategories: [
          {
            id: item.subcategory_id,
            terms: [
              {
                title: this.termName,
                prefix: "",
                impact: "",
                edit: false,
                edit_name: this.termName,
                edit_function: this.termFunction,
                edit_fulfilment_by: this.termFulfilledBy,
                edit_evidence: this.termEvidence,
                edit_domain: this.termDomain,
                edit_defination_of_done: this.termDOD,
                function_id: this.termFunction,
                fulfilment_by: this.termFulfilledBy,
                evidence_id: this.termEvidence,
                domain: this.termDomain,
                defination_of_done: this.termDOD,
              },
            ],
          },
        ],
      },
    ]);
  }

  getCompliance(complianceMet: any) {
    if (complianceMet === true) {
      return "Met";
    } else if (complianceMet === false) {
      return "Not Met";
    } else {
      return "-";
    }
  }

  openRiskInfo(event: Event, item: any) {
    if (event) {
      event.stopPropagation();
    }
    if (!item?.id) {
      return;
    }

    const domainName =
      item?.risk_domain?.name ||
      item?.domain_name ||
      this.grandParentItem?.display_name ||
      this.grandParentItem?.name ||
      "";
    const subdomainName =
      item?.risk_sub_domain?.name ||
      item?.subdomain_name ||
      this.parentItem?.display_name ||
      this.parentItem?.name ||
      "";

    this.spinner.show();
    this.riskService.getRiskById(item.id).subscribe({
      next: (fullRisk: any) => {
        this.spinner.hide();
        const resData = (fullRisk && typeof fullRisk === "object" && "data" in fullRisk && fullRisk.data)
          ? fullRisk.data
          : (fullRisk?.result || fullRisk);
        const mergedRisk = { ...item, ...(typeof resData === "object" ? resData : {}) };
        this.dialog.open(RiskCreateDialogComponent, {
          width: "900px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          disableClose: true,
          data: {
            isEditMode: true,
            isReadOnly: true,
            riskInfo: mergedRisk,
            domainName: domainName,
            subdomainName: subdomainName,
          },
        });
      },
      error: (err: any) => {
        this.spinner.hide();
        console.error("Error fetching risk details", err);
        this.dialog.open(RiskCreateDialogComponent, {
          width: "900px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          disableClose: true,
          data: {
            isEditMode: true,
            isReadOnly: true,
            riskInfo: item,
            domainName: domainName,
            subdomainName: subdomainName,
          },
        });
      },
    });
  }
}
